module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d3xhG"))).then(() => parcelRequire('hEqeo'));